<template>
	<div>
		<table-run
			:columns="columns"
			:rows="rows"
			:option-buttons="optionButtons"
			:include-delete="false"
			:include-export-to-excel="false"
			:include-options="true"
			:include-settings="true"
			:selectable="false"
			@on-sortable-event="columnSortableEvent"
			@on-search-event="searchByColumn"
			@on-delete-event="deleteRow"
			@go-to-edit-page="goToEdit"
			@custom-button="customButton"
			class="no-selectable-table">
			<template slot="rows" scope="props">
				<td>{{ props.row.numReservation }}</td>
				<td>{{ props.row.booking_state }}</td>
				<td>{{ props.row.customer.data.name }} {{ props.row.customer.data.lastname }}</td>
				<td>{{ props.row.country }}</td>
				<td>{{ getChannelData(props.row) }}</td>
				<td>
					<span>{{ props.row.codeRoomtype }}</span>
					<span>{{getRoomCode(props.row)}}</span>
				</td>
				<td>{{ props.row.bookingStart | parseDate('DD/MM/YYYY HH:mm:ss') }}</td>
				<td>{{ props.row.numberNights }}</td>
				<td>{{ props.row.bookingEnd | parseDate('DD/MM/YYYY HH:mm:ss') }}</td>
				<td>{{ props.row.employee_name }}</td>
				<td>${{ props.row.total | round }}</td>
				<td
					:style="getRightColor(props.row)"
				>{{ getPaymentStatus(props.row) }}</td>
			</template>
		</table-run>
		<div class="text-xs-right mt-3">
			<v-pagination
				:length="totalPages"
				:total-visible="pagesVisible"
				v-model="page"
				@input="currentPage"
			></v-pagination>
		</div>
		<menu-list
			:position-x="x"
			:position-y="y"
			:reservation="currentRow"
			:menu-list="filteredMenuList"
			:subsidiary-id="subsidiaryId"
			v-model="showMenu"
			@no-show="noShowBooking"
			@visualize-book="seeBook"
			@open-cancel-modal="openCancelBookingModal"
		/>
		<menu-visualize
			:model="currentRow"
			v-model="modalSeeBooking"
			@close-modal="closeModal('modalSeeBooking')"
		/>
		<menu-no-show
			:model="currentRow"
			v-model="openNoShowModal"
			@close-modal="closeModal('openNoShowModal')"
		/>
		<menu-cancel-booking
			v-model="openCancelModal"
			:booking-code="currentRow.code"
			@close-cancel-modal="closeCancelModal"
			@updated-booking-status="bookingStatusUpdated"
		/>
	</div>
</template>
<script>
import TableRun from 'table-run';
import { format } from 'date-fns';
import { parseDate, round } from '@/shared/filters';
import MenuList from '@/clerkinn/bookings/sub-component/MenuList';
import MenuVisualize from '@/clerkinn/bookings/sub-component/MenuVisualize';
import MenuNoShow from '@/clerkinn/bookings/sub-component/MenuNoShow';
import MenuCancelBooking from '@/clerkinn/bookings/sub-component/MenuCancelBooking';
import lib from '@/shared/lib';

const { matchBetweenArrays, compose, setNewProperty } = lib;

function currentPage(page) {
	this.$emit('input', page);
}

function pagesVisible() {
	return this.totalPages < 5 ? this.totalPages : 5;
}

function columnSortableEvent(value) {
	this.$emit('sortable-event', value);
}

function searchByColumn(value) {
	this.$emit('search-event', value);
}

function deleteRow(value) {
	this.$emit('delete-event', value);
}

function goToEdit(row, event) {
	if (row.bookingState === '0' ||
		row.bookingState === '1' ||
		row.bookingState === '2' ||
		row.bookingState === '3' ||
		row.bookingState === '7'
	) {
		event.stopPropagation();
		event.preventDefault();
		this.x = event.clientX;
		this.y = event.clientY;
		this.showMenu = true;
		this.currentRow = this.transformRow(row);
		this.filteredMenuList = this.filterMenuList(row);
	}
}

function transformRow(row) {
	return compose(
		setNewProperty('flagBilling', false),
		setNewProperty('bookingDate', format(row.bookingDate, 'YYYY-MM-DD')),
	)(row);
}

function customButton(value) {
	this.$emit('custom-button', value);
}

function filterMenuList({ bookingState }) {
	const options = {
		0: matchBetweenArrays.bind(null, [this.menuListAll], [this.menuList, 'code']),
		1: matchBetweenArrays.bind(null, [this.menuListPending], [this.menuList, 'code']),
		2: matchBetweenArrays.bind(null, [this.menuListCheckIn], [this.menuList, 'code']),
		3: matchBetweenArrays.bind(null, [this.menuListCheckOunt], [this.menuList, 'code']),
		7: matchBetweenArrays.bind(null, [this.menuListInHouse], [this.menuList, 'code']),
	};
	return options[bookingState] ? options[bookingState].call() : [];
}

function seeBook() {
	this.modalSeeBooking = true;
}

function closeModal(name) {
	this[name] = false;
}

function noShowBooking() {
	this.openNoShowModal = true;
}

function closeCancelModal() {
	this.openCancelModal = false;
}

function openCancelBookingModal() {
	this.openCancelModal = true;
}

function getRightColor({ paymentStatus }) {
	return (paymentStatus || {}).colors;
}

function getPaymentStatus({ paymentStatus }) {
	return (paymentStatus || {}).name;
}

function bookingStatusUpdated() {
	this.$emit('updated-booking-status');
}

function getRoomCode(book) {
	if (book.room) {
		const room = book.room.data;
		return room.length > 0 ? room.map(r => r.codeRoom).join(', ') : room.codeRoom;
	}
	return null;
}

function getChannelData(book) {
	return book.channel && book.channel.data ? book.channel.data.name : null;
}

function data() {
	return {
		currentRow: {},
		filteredMenuList: [],
		menuList: [
			{ image: '', icon: 'remove_red_eye', title: 'Visualizar', code: 'seeBooking' },
			{ image: '', icon: 'edit', title: 'Editar', name: 'booking-edit', code: 'edit' },
			{
				image: `${this.$imageS3}/clerkinn/checkin-icon.svg`,
				icon: '',
				title: 'CheckIn',
				name: 'checkin-form-tabs',
				code: 'checkin',
			},
			{
				image: `${this.$imageS3}/clerkinn/checkout-icon.svg`,
				icon: '',
				title: 'CheckOut',
				name: 'checkin-form-tabs',
				code: 'checkout',
			},
			{
				image: '',
				icon: '',
				title: 'Cambio de Hab.',
				name: 'booking-edit',
				code: 'roomChange',
			},
			{ image: '', icon: 'cancel', title: 'AnularRva', code: 'cancelBooking' },
			{ image: '', icon: 'print', title: 'Tarjeta de Emb.', code: 'card' },
			{ image: `${this.$imageS3}/clerkinn/no-show-icon.svg`, icon: '', title: 'NoShow', code: 'noShow' },
			{
				image: `${this.$imageS3}/clerkinn/billing-icon.svg`,
				icon: '',
				title: 'Factura',
				name: 'checkin-form-tabs',
				code: 'billing',
			},
			{
				image: `${this.$imageS3}/clerkinn/pay-icon.svg`,
				icon: '',
				title: 'Adelanto',
				name: 'prepayment',
				code: 'advance',
			},
			{
				image: `${this.$imageS3}/clerkinn/billing-icon.svg`,
				icon: '',
				title: 'Detalle Hué',
				name: 'checkin-form-tabs',
				code: 'customer',
			},
		],
		menuListCheckIn: [
			'seeBooking',
			'edit',
			'checkin',
			'roomChange',
			'cancelBooking',
			'card',
			'noShow',
			'billing',
			'advance',
			'customer',
		],
		menuListInHouse: [
			'seeBooking',
			'edit',
			'checkout',
			'billing',
			'roomChange',
			'customer',
		],
		menuListCheckOunt: [
			'seeBooking',
			'edit',
			'checkout',
			'billing',
			'customer',
		],
		menuListPending: [
			'seeBooking',
			'checkin',
			'cancelBooking',
			'card',
			'billing',
			'advance',
			'customer',
		],
		menuListAll: [
			'seeBooking',
		],
		modalSeeBooking: false,
		openCancelModal: false,
		openNoShowModal: false,
		page: 1,
		showMenu: false,
		x: null,
		y: null,
	};
}

export default {
	name: 'booking-table',
	components: {
		MenuCancelBooking,
		MenuList,
		MenuNoShow,
		MenuVisualize,
		TableRun,
	},
	computed: {
		pagesVisible,
	},
	data,
	filters: {
		parseDate,
		round,
	},
	methods: {
		bookingStatusUpdated,
		closeCancelModal,
		closeModal,
		columnSortableEvent,
		currentPage,
		customButton,
		deleteRow,
		filterMenuList,
		getChannelData,
		getPaymentStatus,
		getRightColor,
		getRoomCode,
		goToEdit,
		noShowBooking,
		openCancelBookingModal,
		searchByColumn,
		seeBook,
		transformRow,
	},
	props: {
		columns: {
			default: () => [],
			type: Array,
		},
		currentTab: {
			default: '',
			type: String,
		},
		optionButtons: {
			default: () => [],
			type: Array,
		},
		rows: {
			default: () => [],
			type: Array,
		},
		subsidiaryId: {
			default: 0,
			type: [Number, String],
		},
		totalPages: {
			default: 1,
			type: [String, Number],
		},
	},
};
</script>
<style lang="scss" scoped>
.icon-style {
	font-size: map-get($sizes, sixteen);
}
</style>




// WEBPACK FOOTER //
// booking-table.vue?51f1712d